import React, { useState, useEffect } from 'react';

// ─── Live Ticker Bar ──────────────────────────────────────────────────────────
function LiveTickerBar({ tickers }) {
  return (
    <div className="fish-ticker-bar">
      {tickers.map((t, i) => {
        const value = t.unit === '%'
          ? `${t.price}${t.unit}`
          : t.unit === '$'
            ? `${t.unit}${t.price.toLocaleString()}`
            : `${t.unit} ${t.price.toLocaleString()}`;
        const arrow = t.direction === 'up' ? '▲' : t.direction === 'down' ? '▼' : '';
        const changePct = t.change_pct ? `${Math.abs(t.change_pct).toFixed(2)}%` : '';
        return (
          <span key={t.symbol} className={`fish-ticker-item fish-ticker-${t.direction || 'neutral'}`}>
            <span className="fish-ticker-label">{t.label}</span>
            <span className="fish-ticker-value">{value}</span>
            {changePct && <span className="fish-ticker-change">{arrow} {changePct}</span>}
            {i < tickers.length - 1 && <span className="fish-ticker-sep">·</span>}
          </span>
        );
      })}
    </div>
  );
}

// ─── Predictive Markets Grid ──────────────────────────────────────────────────
function fmtVol(v) {
  if (v >= 1_000_000) return `$${(v / 1_000_000).toFixed(1)}M`;
  if (v >= 1_000)     return `$${(v / 1_000).toFixed(0)}K`;
  return null;
}

function PredictiveMarketsGrid({ markets }) {
  if (!markets.length) return null;
  return (
    <div className="paper-pred-grid">
      {markets.map((m) => {
        const label = (m.question || '').replace(/^Will /, '');
        const vol = fmtVol(m.volume || 0);
        return (
          <a key={m.id || m.slug} href={m.url} target="_blank" rel="noopener noreferrer" className="paper-pred-cell">
            <span className="paper-pred-question">{label}</span>
            <div className="paper-pred-meta">
              <span className="paper-pred-prob">{(m.probability * 100).toFixed(0)}%</span>
              {vol && <span className="paper-pred-vol">{vol}</span>}
            </div>
          </a>
        );
      })}
    </div>
  );
}

// ─── PaperHeader ──────────────────────────────────────────────────────────────
export default function PaperHeader({ section }) {
  const [tickers, setTickers] = useState([]);
  const [markets, setMarkets] = useState([]);

  useEffect(() => {
    const load = async () => {
      try {
        const [tickersRes, marketsRes] = await Promise.all([
          fetch('/api/tickers').then(r => r.json()),
          fetch('/api/paper-markets').then(r => r.json()),
        ]);
        setTickers(Array.isArray(tickersRes) ? tickersRes : []);
        setMarkets(marketsRes.markets || []);
      } catch (e) {
        console.error('Error loading market data:', e);
      }
    };
    load();
    const interval = setInterval(load, 10 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="paper-header">
      <LiveTickerBar tickers={tickers} />
      <PredictiveMarketsGrid markets={markets} />
    </div>
  );
}
